export default __webpack_public_path__ + "static/media/Cloese.a9c61db7.svg";